import { Injectable } from '@angular/core';
import { ContentAssetFolder } from '@r1-compass-library/models';
import { Environment } from '@r1-compass-library/environments/environment';
import { FolderRestService } from './rest/folder-rest.service';
import { BasicFolderSearch } from '@r1-compass-library/models/search/basic-folder-search.model';

@Injectable({ providedIn: 'root' })
export class ContentAssetFolderService extends FolderRestService<ContentAssetFolder, BasicFolderSearch> {
    protected override BASE_URL: string = Environment.baseUrl + '/frontend/content-asset-folders';
    protected override TARGET_OBJECT = 'content-asset-folder';

    processNamePrefix = 'ContentAssetFolderService';
}
